<div class="mat-calendar" fxLayoutAlign="end center">
	<a (click)="openDialog()" class="cursor-pointer">
		<span class="primary-text text-underline">Report Incorrect Data</span>
	</a>
</div>
